import Swiper from 'swiper/dist/js/swiper.min.js';
let scrollTimeout;
let userClickedSlider= false;

jQuery(document).ready(function ($) {
  if (!$('.slider-tech').length) {
    return;
  }

  if ($(window).width() > 768) {
    technologySliderDesktop($);
  }

  if ($(window).width() <= 768) {
    technologySliderMobile($);
  }

});

function technologySliderDesktop($) {
  
  // If url contains hash, show the tab referenced as tab
  if (window.location.hash && $(`.slider-bar[href="${window.location.hash}"]`).length) {
    setActiveSliderBar($(`.slider-bar[href="${window.location.hash}"]`));
  }
  else {
    setActiveSliderBarForScroll();
  }

  $('.slider-bar').on('click', function () {
    userClickedSlider = true;
    setActiveSliderBar(this);
  })

  $('.slider-bar').click(function (e) {
    e.preventDefault();
    var aid = $(this).attr('href');
    $('html,body').animate(
      { scrollTop: $(aid).offset().top },
      'slow'
    );
  });

  $(window).scroll(function () {
    calcFixedSlider();
    setActiveSliderBarForScrollTO();
  });

}

function calcFixedSlider() {
  const scroll = $(window).scrollTop();
  const triggerPoint = $('.technology-slider').offset().top 
  - $('#wpadminbar').outerHeight() 
  - $('.grid-row').outerHeight();

  if (scroll > triggerPoint && scroll < 5000) {
    $('.slider-tabs').addClass('fixed');
    // change main menu background to dark (by removing class dark) if not mobile display
    if (!window.matchMedia('(max-width: 768px)').matches) {
      $('.header').removeClass('dark');
    }
  } else {
    $('.slider-tabs').removeClass('fixed');
    // change main menu background to white (by adding class dark) if not mobile display
    if (!window.matchMedia('(max-width: 768px)').matches) {
      $('.header').addClass('dark');
    }
  }
}

function setActiveSliderBarForScrollTO() {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(function () {
    setActiveSliderBarForScroll();
  }, 100); //Timeout needed to establish the exact location after scrolling
}

// This function calculates the block which is currently displayed.
// At the same time the function counts the block-anchors up to the currently displayed block. 
// These blocks are represented as a tab in the slider bar, so the number of block-anchors
// is the index of the highlighted tab in the slider bar.
function setActiveSliderBarForScroll() {
  if (userClickedSlider) // There is no need to recalculate after slider-bar was clicked
  {
    userClickedSlider = false;
    return;
  }
  const yOffset = $(window).scrollTop() + $('.slider-bar-container').height() + $('#wpadminbar').outerHeight();
  let anchorIndex = -1;
  $('.block').each(function () {
    if ($(this).find('.block-anchor').length > 0 || $(this).hasClass('block-anchor')) {
      anchorIndex++;
    }
    if ($(this).offset().top + $(this).outerHeight() > yOffset) {
      $('.block').removeClass('current');
      $(this).addClass('current');
      // anchorIndex represents the correct index in the slider bar including cases when
      // the current block is not an anchor block.
      if (anchorIndex < 0) {  // for cases when the current block is before the first anchor
        anchorIndex = 0;
      }
      setActiveSliderBar($('.slider-bar').eq(anchorIndex));
      return false; // stops the iteration after the apropriate block identified
    }
  });
}


function technologySliderMobile($) {
  $('.slider-list-container').addClass('swiper-wrapper');
  new Swiper('.slider-list-box', {
    spaceBetween: 20,
    slidesPerView: 1,
  });
}

function setActiveSliderBar(activeEl) {
  let tab = '';
  $('.slider-bar').removeClass('active');
  if (activeEl) {
    $(activeEl).addClass('active');

    $('.slider-bar .bottom-line').removeClass('tab-0 tab-1 tab-2');
    let index = $('.slider-bar').index(activeEl);
    tab = 'tab-' + index;
  }
  $('.slider-bar .bottom-line').addClass(tab);
}



// WEBPACK FOOTER //
// ./scripts/blocks/technology-slider.js